import {fetchGet} from "../services/api";
import {IUser} from "../models/user";

export const fetchMe = (): Promise<IUser> => {
    return fetchGet( '/users/me').then(data => data);
};
